import React, { useEffect, useRef, useState } from 'react'
import { Alert, Form, Input, Modal, Select } from 'antd'
import { menuAdminRequest, errorMessage } from './api'
import { METHODS, relationOnly } from './model'
import HelpHint from './HelpHint'

// 2026-10-20 coder(lq): 菜单来自真实权限源，异步搜索只接受最后一次结果，避免切换系统后串选。
export default function RelationEditor({ current, initial: selectedMenu, visible, onCancel, onReview }) {
    const [form] = Form.useForm()
    const [scope, setScope] = useState({ authority: 'baseservice', service: '' })
    const [search, setSearch] = useState('')
    const [menus, setMenus] = useState([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const requestId = useRef(0)
    useEffect(() => {
        if (!visible) return
        const initial = current ? relationOnly(current) : { authority: 'baseservice', http_method: 'GET', ...selectedMenu }
        form.resetFields(); form.setFieldsValue(initial)
        setScope({ authority: initial.authority, service: initial.service_id || '' })
        setSearch(initial.resource_id ? String(initial.resource_id) : '')
        setMenus(selectedMenu && !current ? [{ resourceId: selectedMenu.resource_id, menuName: selectedMenu.menuName, status: selectedMenu.status }] : [])
        setError('')
    }, [visible, current, selectedMenu, form])
    useEffect(() => {
        const id = ++requestId.current
        if (!visible || !scope.service) { setMenus([]); setLoading(false); return undefined }
        const timer = setTimeout(() => {
            setLoading(true); setError('')
            menuAdminRequest('menus', { params: { ...scope, search } }).then(result => {
                if (id === requestId.current) setMenus(result)
            }).catch(err => { if (id === requestId.current) setError(errorMessage(err)) })
                .finally(() => { if (id === requestId.current) setLoading(false) })
        }, 300)
        return () => { clearTimeout(timer); requestId.current += 1 }
    }, [visible, scope, search])
    const scopeChanged = changed => {
        if (changed.authority !== undefined || changed.service_id !== undefined) {
            const authority = form.getFieldValue('authority')
            const service = authority === 'cms-native' ? 'LECHUN-CMS' : (form.getFieldValue('service_id') || '')
            form.setFieldsValue({ resource_id: undefined, service_id: service })
            setScope({ authority, service }); setSearch(''); setMenus([])
        }
    }
    return <Modal title={<>{current ? '修改菜单接口关系' : '新增菜单接口关系'}
        <HelpHint label="编辑菜单接口关系说明">一个接口可关联多个菜单；满足任一有效菜单权限即可通过。系统归属取自服务端策略，不从接口前缀推断。</HelpHint></>} open={visible}
        onCancel={onCancel} onOk={() => form.validateFields().then(values => onReview(relationOnly(values))).catch(() => {})}
        okText="核对变更" cancelText="取消" destroyOnClose maskClosable={false}>
        <Form form={form} layout="vertical" onValuesChange={scopeChanged}>
            <Form.Item name="authority" label="菜单权限来源" rules={[{ required: true }]}>
                <Select options={[{ value: 'baseservice', label: '统一权限' }, { value: 'cms-native', label: 'CMS 原生权限' }]} />
            </Form.Item>
            <Form.Item name="service_id" label="菜单所属服务标识" rules={[{ required: true }, { pattern: /^[A-Za-z0-9_-]{1,64}$/, message: '请输入有效服务标识' }]}>
                <Input placeholder="例如 LECHUN-CSMS；不是接口目标服务" maxLength={64} disabled={scope.authority === 'cms-native'} />
            </Form.Item>
            <Form.Item name="resource_id" label="菜单（sourceid / resourceId）" rules={[{ required: true, message: '请选择真实菜单' }]}>
                <Select showSearch filterOption={false} onSearch={setSearch} loading={loading}
                    placeholder="先填写服务标识，再搜索菜单名称或ID" notFoundContent={loading ? '正在读取菜单…' : '未找到菜单，请检查来源和服务标识'}
                    options={menus.map(menu => ({ value: menu.resourceId, label: `${menu.menuName}（#${menu.resourceId}）${menu.status === 1 ? '' : ' 已停用'}`, disabled: menu.status !== 1 }))} />
            </Form.Item>
            {error && <Alert type="error" showIcon message={error} />}
            {menus.length > 200 && <Alert type="info" message="匹配菜单超过200条，请输入更具体的名称或ID。" />}
            <Form.Item name="http_method" label="请求方法" rules={[{ required: true }]}><Select options={METHODS.map(value => ({ value }))} /></Form.Item>
            <Form.Item name="api_path" label="接口路径" rules={[{ required: true }, { pattern: /^\//, message: '路径必须以 / 开头' }]}>
                <Input maxLength={512} placeholder="/服务前缀/接口；单段参数可用 {id}，不含域名或查询串" />
            </Form.Item>
        </Form>
    </Modal>
}
